"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const video_client_core_1 = require("@video/video-client-core");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const videoStyles_1 = require("../../../../styling/videoStyles");
const SelectNonNative_1 = tslib_1.__importDefault(require("../../../../ui-lib/Inputs/SelectNonNative"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
const styles_1 = tslib_1.__importDefault(require("./styles"));
const ModularQualitySelect = (0, mobx_react_lite_1.observer)(({ classes = {}, disableSelect, showBitrate, ...props }) => {
    var _a;
    const componentName = "<QualitySelect/>";
    /**
     * Access PlayerUiContext.
     */
    const ctx = (0, react_1.useContext)(context_1.PlayerUiContext);
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes, target: styles_1.default }, "quality-select");
    /**
     * Throw error (and trigger ErrorBoundary) if store is undefined.
     * */
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.player) != null, componentName);
    /**
     * Returns true if the given score matches the current quality.
     */
    function isSelected(score) {
        if (!(ctx === null || ctx === void 0 ? void 0 : ctx.player.isImplements(video_client_core_1.player.Feature.BITRATE_SWITCHING))) {
            return false;
        }
        return score === ctx.player.preferredLevel;
    }
    /**
     * Select the closest quality to the given score if player supports bitrate switching.
     * Otherwise, it does nothing.
     */
    function selectQuality(score) {
        if (ctx === null || ctx === void 0 ? void 0 : ctx.player.isImplements(video_client_core_1.player.Feature.BITRATE_SWITCHING)) {
            ctx.player.preferredLevel = score;
        }
    }
    function showBitrateText(formattedBitrate) {
        if (!showBitrate || formattedBitrate == null || formattedBitrate === "") {
            return "";
        }
        return formattedBitrate;
    }
    if (!((_a = ctx === null || ctx === void 0 ? void 0 : ctx.player) === null || _a === void 0 ? void 0 : _a.isImplements(video_client_core_1.player.Feature.BITRATE_SWITCHING))) {
        return null;
    }
    return (react_1.default.createElement(SelectNonNative_1.default, { ...props, className: mergedClasses.root }, ctx.availableBitrates.map((layer) => (react_1.default.createElement("div", { role: "button", tabIndex: 0, onKeyDown: (e) => e.key === "Enter" && layer.score !== undefined && selectQuality(layer.score), key: layer.score, id: layer.score, onClick: () => selectQuality(layer.score), className: isSelected(layer.score) ? mergedClasses.activeOption : mergedClasses.option },
        react_1.default.createElement("label", { htmlFor: "layer.score" },
            layer.name,
            " ",
            showBitrateText(layer.formattedBitrate)))))));
});
function QualitySelectWithErrorBoundary({ classes, ...props }) {
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes !== null && classes !== void 0 ? classes : {}, target: styles_1.default }, "select");
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => (react_1.default.createElement(SelectNonNative_1.default, { ...props, className: mergedClasses.root },
            react_1.default.createElement("div", { key: "", id: "disabled-select", className: mergedClasses.disabledOption }, "Qualities Unavailable"))) },
        react_1.default.createElement(ModularQualitySelect, { ...props })));
}
exports.default = QualitySelectWithErrorBoundary;
//# sourceMappingURL=QualitySelect.js.map